/* global axios */
import ApiClient from '../ApiClient';

class InternalMembers extends ApiClient {
  constructor() {
    super('internal/rooms', { accountScoped: true });
  }

  getMembers(roomId) {
    return axios.get(`${this.url}/${roomId}/members`);
  }

  addMember(roomId, userId) {
    return axios.post(`${this.url}/${roomId}/members`, { user_id: userId });
  }

  removeMember(roomId, memberId) {
    return axios.delete(`${this.url}/${roomId}/members/${memberId}`);
  }
}

export default new InternalMembers();
